module.exports = __webpack_public_path__ + "img/gray-whatsapp-icon.9d5502ce.svg";